export default [
    {
        target: '[data-swiper="cases"]',
        file: async () =>
            (await import(/* webpackChunkName: "scripts/elements/cases" */'./cases/slider')).default,
    },
    {
        target: '[data-swiper="cases"]',
        file: async () =>
            (await import(/* webpackChunkName: "scripts/elements/cases" */'./cases/modal')).default,
    }
]